var SCROLL_ANIMATION_QUEUE_NAME = 'rwScrollAnimations';

var Q = require('q'),
	currentScrollPriority = null,
	$page = $('html, body'),
	utilities = require('utilities');

const hasVerticalScrollBars = el => {
	return el.scrollHeight > el.clientHeight;
};

/**
 * Scroll to top position
 * @param  {Number|Object}	positionOrElement   Element (jQuery object) or position top to scroll to
 * @param  {Object} 		options
 *         {Number}			[options.duration] 	Duration of scroll animation, in ms. Defaults to 0 (no animation).
 *         {Number}			options.priority 	Priority of scroll, a new scroll with priority > current scroll will override current scroll,
 *         								a new scroll with priority < current scroll will be ignored.
 * @return {Object}          			Promise to be resolved if and when scroll is complete
 */
var scrollManager = function (positionOrElement, options, elementToScroll) {
	if (!options || typeof options.priority !== 'number') {
		throw new TypeError('options.priority must be specified as a number!');
	}

	var duration = options.duration || 0,
		priority = options.priority,
		position = positionOrElement;

	elementToScroll = elementToScroll ? $(elementToScroll) : $page;

	if (elementToScroll !== $page && elementToScroll.length === 1) {
		let elementIsScrollable = hasVerticalScrollBars(elementToScroll.get(0));
		let parents = elementToScroll.parents().toArray();
		let foundScrollBars =
			elementIsScrollable ||
			!parents.every(parent => {
				if (hasVerticalScrollBars(parent)) {
					elementToScroll = $(parent);
					return false;
				}
				return true;
			});

		if (!foundScrollBars) {
			elementToScroll = $page;
		} else {
			positionOrElement = $(positionOrElement);
			position = positionOrElement.offset().top - elementToScroll.offset().top;
		}
	}

	// ios must include BODY tag and html tag if scrolling the entire page
	if (elementToScroll !== $page && elementToScroll[0].tagName === 'HTML') {
		elementToScroll = $page;
	}

	if (typeof positionOrElement === 'object' && elementToScroll === $page) {
		positionOrElement = $(positionOrElement);

		var offset = 0;

		positionOrElement.parents().each(function (i, node) {
			var $node = $(node);

			scrollManager.headers.forEach(function (header) {
				header.els.each(function (i2, n2) {
					if (n2 === node) {
						offset += $node.outerHeight();
					}
				});
			});

			$node.prevAll().each(function (i2, node2) {
				scrollManager.headers.forEach(function (header) {
					header.els.each(function (i3, n2) {
						if (n2 === node2) {
							offset += $(node2).outerHeight();
						}
					});
				});
			});
		});

		position = (offset ? utilities.findPosY(positionOrElement[0]) - offset : positionOrElement.offset().top) + 1;
	}

	if (currentScrollPriority === null || currentScrollPriority < priority) {
		currentScrollPriority = priority;

		elementToScroll.stop(SCROLL_ANIMATION_QUEUE_NAME, true);

		var deferred = Q.defer();

		elementToScroll
			.animate(
				{
					scrollTop: position
				},
				{
					queue: SCROLL_ANIMATION_QUEUE_NAME,
					duration: duration,
					complete: function () {
						// Protect against double callback calls, since jQuery calls this once per element found,
						// and we're scrolling on 'html' and 'body' for cross-browser purposes
						if (deferred.promise.inspect().state === 'pending') {
							setTimeout(function () {
								deferred.resolve();

								currentScrollPriority = null;
							}, 10);
						}
					}
				}
			)
			.promise()
			.fail(function () {
				// Protect against double callback calls, since jQuery calls this once per element found,
				// and we're scrolling on 'html' and 'body' for cross-browser purposes
				if (deferred.promise.inspect().state === 'pending') {
					setTimeout(function () {
						deferred.reject();

						currentScrollPriority = null;
					}, 10);
				}
			});

		elementToScroll.dequeue(SCROLL_ANIMATION_QUEUE_NAME);

		return deferred.promise;
	} else {
		return Q.reject(new Error('Rejecting lower priority scroll.'));
	}
};

scrollManager.headers = [];

module.exports = scrollManager;
